const permissao = {
  LISTAR_USUARIOS: 'LISTAR_USUARIOS',
  CADASTRAR_USUARIO: 'CADASTRAR_USUARIO',
  CADASTRAR_PESSOA: 'CADASTRAR_PESSOA',
  ENVIAR_EMAIL_USUARIO: 'ENVIAR_EMAIL_USUARIO',
  REDEFINIR_SENHA: 'REDEFINIR_SENHA',
  PESQUISAR_PROCESSOS: 'PESQUISAR_PROCESSOS',
  BAIXAR_DOCUMENTOS: 'BAIXAR_DOCUMENTOS',
  VIEW_ANALISE: 'VIEW_ANALISE',
  VALIDAR_ANALISE: 'VALIDAR_ANALISE',
  ENCAMINHAR_ANALISE_VALIDACAO: 'ENCAMINHAR_ANALISE_VALIDACAO',
  ENCAMINHAR_ANALISE_SETOR: 'ENCAMINHAR_ANALISE_SETOR',
  VIEW_RESPONSAVEL: 'VIEW_RESPONSAVEL',
  VIEW_VALIDACAO_DOCUMENTOS: 'VIEW_VALIDACAO_DOCUMENTOS',
  VIEW_LEGISLACAO: 'VIEW_LEGISLACAO',
  VINCULAR_TROCAR_ANALISTA: 'VINCULAR_TROCAR_ANALISTA',
  VINCULAR_TROCAR_GERENTE: 'VINCULAR_TROCAR_GERENTE',
  TROCAR_ATENDENTE: 'TROCAR_ATENDENTE',
  SEARCH_USUARIOS_PERFIL: 'SEARCH_USUARIOS_PERFIL',
  VIEW_PROCESSOS_GERENTE_CDI: 'VIEW_PROCESSOS_GERENTE_CDI',
  SEARCH_USUARIOS_ANALISTAS: 'SEARCH_USUARIOS_ANALISTAS',
  VINCULAR_EQUIPE: 'VINCULAR_EQUIPE',
  VIEW_PROCESSOS_VINCULO_ANALISTA: 'VIEW_PROCESSOS_VINCULO_ANALISTA',
  INICIAR_ANALISE_CAF: 'INICIAR_ANALISE_CAF',
  PESQUISAR_OS: 'PESQUISAR_OS',
  VIEW_ORDEM_SERVICO: 'VIEW_ORDEM_SERVICO',
  VIEW_FUNCAO: 'VIEW_FUNCAO',
  VIEW_STATUS_OS: 'VIEW_STATUS_OS',
  VIEW_PROCESSOS_GERENTE_GEO: 'VIEW_PROCESSOS_GERENTE_GEO',
  VIEW_PROCESSOS_ANALISTA_GEO: 'VIEW_PROCESSOS_ANALISTA_GEO',
  CREATE_VALICACAO_ANALISE_CAF: 'CREATE_VALICACAO_ANALISE_CAF',
  ENCAMINHAR_ANALISE_ADMINISTRATIVO: 'ENCAMINHAR_ANALISE_ADMINISTRATIVO',
  VALIDAR_PORTARIA: 'VALIDAR_PORTARIA',
  VIEW_LOCALIZACOES: 'VIEW_LOCALIZACOES',
  BAIXAR_SHAPE: 'BAIXAR_SHAPE',
  ENCAMINHAR_ANALISE_DIRETOR: 'ENCAMINHAR_ANALISE_DIRETOR',
  SOLICITAR_REVISAO: 'SOLICITAR_REVISAO',
  RESPOSTA_REVISAO: 'RESPOSTA_REVISAO',
  ARQUIVAR_PROCESSO: 'ARQUIVAR_PROCESSO',
  SOLICITAR_ARQUIVAMENTO: 'SOLICITAR_ARQUIVAMENTO',
  ENCAMINHAR_ANALISE_VALIDACAO_COORDENADOR: 'ENCAMINHAR_ANALISE_VALIDACAO_COORDENADOR',
  SOLICITAR_REVISAO_PROCURADOR: 'SOLICITAR_REVISAO_PROCURADOR',
  ENCAMINHAR_ANALISE_PRESIDENTE: 'ENCAMINHAR_ANALISE_PRESIDENTE',
  PUBLICAR_PORTARIA: 'PUBLICAR_PORTARIA',
  ACUSAR_PUBLICACAO: 'ACUSAR_PUBLICACAO',
  VIEW_INFORMACOES_TITULO: 'VIEW_INFORMACOES_TITULO',
  ACUSAR_RECEBIMENTO: 'ACUSAR_RECEBIMENTO',
  CONFIRMAR_ENTREGA: 'CONFIRMAR_ENTREGA',
  ACUSAR_ENTREGA: 'ACUSAR_ENTREGA',
  VIEW_ANOTACOES_DIRETOR: 'VIEW_ANOTACOES_DIRETOR',
  VIEW_TITULO: 'VIEW_TITULO',
  VALIDAR_ATUALIZACAO_BASE: 'VALIDAR_ATUALIZACAO_BASE',
  ENVIAR_MENSAGEM: 'ENVIAR_MENSAGEM',
  NOTIFICAR_INTERESSADO: 'NOTIFICAR_INTERESSADO',
  ELABORAR_EDITAL: 'ELABORAR_EDITAL',
  ENCAMINHAR_ANALISE_SUBPROCURADOR: 'ENCAMINHAR_ANALISE_SUBPROCURADOR',
  ENCAMINHAR_ANALISE_VINCULAR_EQUIPE: 'ENCAMINHAR_ANALISE_VINCULAR_EQUIPE',
  VIEW_PROCESSOS_OS: 'VIEW_PROCESSOS_OS',
  VIEW_DIAS: 'VIEW_DIAS',
  CADASTRAR_EDITAL: 'CADASTRAR_EDITAL',
  ENCAMINHAR_PUBLICACAO: 'ENCAMINHAR_PUBLICACAO',
  EXPORTAR_CSV_BENEFICIARIOS: 'EXPORTAR_CSV_BENEFICIARIOS',
  SOLICITAR_REVISAO_SUB_PROCURADOR: 'SOLICITAR_REVISAO_SUB_PROCURADOR',
  EMITIR_BOLETO: 'EMITIR_BOLETO',
  VISUALIZAR_RELATORIOS: 'VISUALIZAR_RELATORIOS',
  GET_MUNICIPIOS: 'GET_MUNICIPIOS',
  GET_RECEITAS: 'GET_RECEITAS',
  PESQUISAR_CADASTROS: 'PESQUISAR_CADASTROS',
  UPDATE_CADASTROS: 'UPDATE_CADASTROS',
  DELETE_CADASTROS: 'DELETE_CADASTROS',
  PESQUISAR_CONVERSAS: 'PESQUISAR_CONVERSAS',
  UPDATE_CONVERSAS: 'UPDATE_CONVERSAS',
  DELETE_CONVERSAS: 'DELETE_CONVERSAS',
  PESQUISAR_MENSAGENS: 'PESQUISAR_MENSAGENS',
  UPDATE_MENSAGENS: 'UPDATE_MENSAGENS',
  PESQUISAR_PERFIL: 'PESQUISAR_PERFIL',
  PESQUISAR_MOTIVOS: 'PESQUISAR_MOTIVOS',
  DOWNLOAD_DECLARACAO: 'DOWNLOAD_DECLARACAO',
  VIEW_SITUACAO: 'VIEW_SITUACAO',
  UPLOAD_TERMOS: 'UPLOAD_TERMOS',
  ANALISAR_FINALIZADO: 'ANALISAR_FINALIZADO',
  PESQUISAR_SETORES: 'PESQUISAR_SETORES',
  VINCULAR_USUARIOS_PROCESSOS: 'VINCULAR_USUARIOS_PROCESSOS',
  PESQUISAR_PROCESSO_SIG: 'PESQUISAR_PROCESSO_SIG',
  CONSULTAR_PROCESSOS: 'CONSULTAR_PROCESSOS',
  PESQUISAR_USUARIOS: 'PESQUISAR_USUARIOS',
  VIEW_RELATORIOS_COF: 'VIEW_RELATORIOS_COF',
  CONSULTAR_HISTORICO: 'CONSULTAR_HISTORICO',
  PESQUISAR_PROCESSOS_EXTERNO: 'PESQUISAR_PROCESSOS_EXTERNO',
  BAIXAR_SHAPE_SIG: 'BAIXAR_SHAPE_SIG',
  ENCAMINHAR_ANALISE_RESPONSAVEIS_DIRETOS: 'ENCAMINHAR_ANALISE_RESPONSAVEIS_DIRETOS',
  ENCAMINHAR_ANALISE_PROCURADOR_JURIDICO: 'ENCAMINHAR_ANALISE_PROCURADOR_JURIDICO',
  ENCAMINHAR_ANALISE_PROCURADOR_ADMINISTRATIVO: 'ENCAMINHAR_ANALISE_PROCURADOR_ADMINISTRATIVO',
  ADICIONAR_TIPO_PROCESSO_VINCULO: 'ADICIONAR_TIPO_PROCESSO_VINCULO',
  AVOCAR_PROCESSO_DIRETOR: 'AVOCAR_PROCESSO_DIRETOR',
  AVOCAR_PROCESSO_PROCURADORIA: 'AVOCAR_PROCESSO_PROCURADORIA',
  ALTERAR_REL_TIPO_PROCESSO_USUARIO: 'ALTERAR_REL_TIPO_PROCESSO_USUARIO',
  ALTERAR_PERFIL: 'ALTERAR_PERFIL',
  VIZUALIZAR_HISTORICO: 'VIZUALIZAR_HISTORICO',
  DOWNLOAD_DOCUMENTO: 'DOWNLOAD_DOCUMENTO',
  EDITAR_BENEFICIARIO: 'EDITAR_BENEFICIARIO',
  PESQUISAR_PRODUTIVIDADE: 'PESQUISAR_PRODUTIVIDADE',
  PESQUISAR_RELATORIOS: 'PESQUISAR_RELATORIOS',
  PESQUISAR_PROCESSOS_CENTRAL: 'PESQUISAR_PROCESSOS_CENTRAL',
  BAIXAR_DOCUMENTOS_CENTRAL: 'BAIXAR_DOCUMENTOS_CENTRAL',
  VIEW_DAES: 'VIEW_DAES',
  AVOCAR_PROCESSO_GEO: 'AVOCAR_PROCESSO_GEO',
  CADASTRAR_MODELO_DESPACHO: 'CADASTRAR_MODELO_DESPACHO',
  EDITAR_MODELO_DESPACHO: 'EDITAR_MODELO_DESPACHO',
  LISTAR_MODELO_DESPACHO: 'LISTAR_MODELO_DESPACHO',
  REMOVER_MODELO_DESPACHO: 'REMOVER_MODELO_DESPACHO',
  MANEJAR_CADASTROS_EM_ANDAMENTO: 'MANEJAR_CADASTROS_EM_ANDAMENTO',
  EXPORTAR_CSV_DASHBOARD_RELATORIOS: 'EXPORTAR_CSV_DASHBOARD_RELATORIOS',
  VIEW_MUNICIPIOS_OS: 'VIEW_MUNICIPIOS_OS',
  CADASTRAR_TITULO_PROCESSO: 'CADASTRAR_TITULO_PROCESSO',
  SOLICITAR_RETIFICACAO: 'SOLICITAR_RETIFICACAO',
  ASSINAR_TITULO: 'ASSINAR_TITULO',
  ASSINAR_TODOS_TITULOS: 'ASSINAR_TODOS_TITULOS',
  SOLICITAR_INFORMACAO: 'SOLICITAR_INFORMACAO',
  ANALISAR_PROCESSO: 'ANALISAR_PROCESSO',
  ANALISAR_SUB_PROCESSO: 'ANALISAR_SUB_PROCESSO',
  VALIDAR: 'VALIDAR',
  VISUALIZAR_PROCESSO: 'VISUALIZAR_PROCESSO',
  TROCAR_RESPONSAVEL: 'TROCAR_RESPONSAVEL',
  EMITIR: 'EMITIR',
  DAES: 'DAES',
  VINCULAR_ANALISTA: 'VINCULAR_ANALISTA',
  AVOCAR_PROCESSO: 'AVOCAR_PROCESSO',
  ATUALIZAR_BASE: 'ATUALIZAR_BASE',
  REVISAR_ANALISE: 'REVISAR_ANALISE',
  EM_REVISAO: 'EM_REVISAO',
  CONTINUAR_ANALISE: 'CONTINUAR_ANALISE',
  RETIFICAR_PROCESSO: 'RETIFICAR_PROCESSO',
  CADASTRAR_PORTARIA: 'CADASTRAR_PORTARIA',
  REVISAR_PORTARIA: 'REVISAR_PORTARIA',
  VISUALIZAR_INFORMACOES_CERTICAO_TITULO: 'VISUALIZAR_INFORMACOES_CERTICAO_TITULO',
  CONTINUAR_EMISSAO_TITULO: 'CONTINUAR_EMISSAO_TITULO',
  CONTINUAR_EMISSAO_CERTIDAO: 'CONTINUAR_EMISSAO_CERTIDAO',
  CONFERIR_TITULO: 'CONFERIR_TITULO',
  CONFERIR_CERTIDAO: 'CONFERIR_CERTIDAO',
  VIEW_CAIXA_DE_ENTRADA: 'VIEW_CAIXA_DE_ENTRADA',
  CAIXA_ENTRADA_OS: 'CAIXA_ENTRADA_OS',
  VIEW_EM_ANALISE_OS: 'VIEW_EM_ANALISE_OS',
  VIEW_EM_ANALISE: 'VIEW_EM_ANALISE',
  VIEW_AGUARDANDO_VALIDACAO: 'VIEW_AGUARDANDO_VALIDACAO',
  VIEW_TITULO_CERTIDAO: 'VIEW_TITULO_CERTIDAO',
  VIEW_PROCESSOS_ARQUIVADOS: 'VIEW_PROCESSOS_ARQUIVADOS',
  VIEW_PROCESSOS_ARQUIVADOS_SETOR: 'VIEW_PROCESSOS_ARQUIVADOS_SETOR',
  VIEW_PROCESSOS: 'VIEW_PROCESSOS',
  VIEW_AGUARDANDO_ATUALIZACAO_BASE: 'VIEW_AGUARDANDO_ATUALIZACAO_BASE',
  VIEW_EDITAL_PUBLICACAO: 'VIEW_EDITAL_PUBLICACAO',
  VIEW_AGUARDANDO_MANIFESTACAO: 'VIEW_AGUARDANDO_MANIFESTACAO',
  VIEW_PROCESSOS_FINALIZADOS: 'VIEW_PROCESSOS_FINALIZADOS',
  VIEW_PORTARIAS: 'VIEW_PORTARIAS',
  VIEW_PUBLICACAO: 'VIEW_PUBLICACAO',
  VIEW_DOCUMENTOS: 'VIEW_DOCUMENTOS',
  VIEW_ARQUIVOS: 'VIEW_ARQUIVOS',
  VIEW_ASSINATURAS: 'VIEW_ASSINATURAS',
  VIEW_CAIXA_ASSINATURA_REURB: 'VIEW_CAIXA_ASSINATURA_REURB',
  VIEW_ANALISE_CONJUNTA: 'VIEW_ANALISE_CONJUNTA',
  VIEW_RELATORIOS: 'VIEW_RELATORIOS',
  VIEW_CAIXA_CUSTAS: 'VIEW_CAIXA_CUSTAS',
  GERAR_CUSTA: 'GERAR_CUSTA',
  EMITIR_TITULO: 'EMITIR_TITULO',
  EMITIR_CERTIDAO: 'EMITIR_CERTIDAO',
  REVISAR_VALIDACAO_ANALISE: 'REVISAR_VALIDACAO_ANALISE',
  VIEW_CAIXA_ENVIO_CARTORIO: 'VIEW_CAIXA_ENVIO_CARTORIO',
  VIEW_CAIXA_ENVIO_REGISTRO_CARTORIO: 'VIEW_CAIXA_ENVIO_REGISTRO_CARTORIO',
  PUBLICAR_TERMO_RETIICACAO: 'PUBLICAR_TERMO_RETIFICACAO',
  VIEW_PROCESSOS_ANALISADOS: 'VIEW_PROCESSOS_ANALISADOS',
  VIEW_EMISSAO_CUSTAS_CERTIDAO: 'VIEW_EMISSAO_CUSTAS_CERTIDAO',
  GERAR_CUSTAS_CERTIDAO: 'GERAR_CUSTAS_CERTIDAO',
  VIEW_PROCESSOS_ASSINADOS: 'VIEW_PROCESSOS_ASSINADOS',
  VIEW_MENU_GESTAO_VTN: 'VIEW_MENU_GESTAO_VTN',
  VIEW_DAES_VTN: 'VIEW_DAES_VTN',
  VIEW_RELATORIO_GRF_CAF_CREDENCIADOS: 'VIEW_RELATORIO_GRF_CAF_CREDENCIADOS',
  VIEW_PROCESSOS_PENDENCIA: 'VIEW_PROCESSOS_PENDENCIA',
  DESARQUIVAR_PROCESSO: 'DESARQUIVAR_PROCESSO',
  EMITIR_EXTRATO_SENTENCA: 'EMITIR_EXTRATO_SENTENCA',
  VIEW_TITULOS_PARA_ENTREGA: 'VIEW_TITULOS_PARA_ENTREGA',
  VIEW_ACAO_IMPRESSAO_TITULO_E_DOCUMENTOS: 'VIEW_ACAO_IMPRESSAO_TITULO_E_DOCUMENTOS',
  VIEW_CAIXA_CADASTROS_EM_ANDAMENTO: 'VIEW_CAIXA_CADASTROS_EM_ANDAMENTO',
  VIEW_CAIXA_BUSCAR_PROCESSOS: 'VIEW_CAIXA_BUSCAR_PROCESSOS',
  VIEW_CAIXA_SOLICITACOES: 'VIEW_CAIXA_SOLICITACOES',
  VIEW_PROCESSOS_SUSPENSOS: 'VIEW_PROCESSOS_SUSPENSOS',
  SUSPENDER: 'SUSPENDER',
  CANCELAR_SUSPENSAO: 'CANCELAR_SUSPENSAO'
}

export default permissao



// WEBPACK FOOTER //
// ./src/utils/permissao.js